import axios from 'axios'

const { REACT_APP_PAY_WS_URL } = process.env

export const NewPayService = axios.create({ baseURL: REACT_APP_PAY_WS_URL || '' })
